<template>
  <pt-lab-test-platform-list class="pt-lab-test-platform-list__withData"></pt-lab-test-platform-list>
</template>

<script>
import PtLabTestPlatformList from './index'
export default {
  name: 'pt-lab-test-platform-list__withData',
  components: {
    'pt-lab-test-platform-list': PtLabTestPlatformList
  }
}
</script>
